<template>
  <b-modal
    :id="id"
    :ok-title="trans('close')"
    ok-only
    @shown="onShown"
    @hidden="onHidden"
  >
    <template #modal-title>
      <div v-if="!!location">
        {{ location.name }}
        <small class="text-muted">
          #{{ location.id }}
        </small>
        <small v-if="!!location.alias || !!location.sku" class="d-block text-muted">
          {{ compact([location.alias, location.sku]).join(', ') }}
        </small>
      </div>
      <div v-if="!location && !!locations" v-for="l in locations" :key="l.id">
        {{ l.name }}
        <small class="text-muted">
          #{{ l.id }}
        </small>
      </div>
    </template>

    <div v-if="visible">
      <p>
        {{ trans('conflict') }} @
        {{ timeRangeStr(start, end) }}
      </p>
      <ul>
        <li v-for="e in events" :key="e.id" class="text-danger">
          {{ getBookingName(e) }} @ {{ timeRangeStr(e.start, e.end) }}
        </li>
      </ul>
      <ul>
        <li v-for="e in notAvailableEvents" :key="e.id" class="text-danger">
          {{trans('unavailable')}} @ {{ timeRangeStr(e.start, e.end) }}
        </li>
      </ul>
    </div>

  </b-modal>
</template>

<script>
  export default {
    props: {
      id: {
        type: String,
        default: 'location-conflicts-modal',
      },
      organization: Object,
      location: Object, // use this
      locations: Array, // or this
      start: Object|String,
      end: Object|String,
      events: Array,
      notAvailableEvents: Array,
    },
    data() {
      return {
        trans: trans,
        moment: moment,
        timeRangeStr: _.timeRangeStr,
        compact: _.compact,
        visible: false,
      }
    },
    methods: {
      getBookingName(event) {
        if (!event) return null
        return _.uniq(_.compact([
          (event.extendedProps.client || event.title),
          event.extendedProps.package_name,
          event.extendedProps.booking_type,
        ])).join(', ')
      },
      onShown() {
        this.visible = true
      },
      onHidden() {
        this.visible = false
      },
    }
  }
</script>